import { UsersDataTable } from '@/components/(user_table)/components/UsersDataTable'
import { usersTableColumns } from '@/components/(user_table)/components/usersTableColumns'
import { DashboardHeader } from '@/components/dashboard/dashboard-header'
import { DashboardShell } from '@/components/dashboard/dashboard-shell'
import { Skeleton } from '@/components/ui/skeleton'
import { useTRPC } from '@/trpc/react'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/admin/super_admin/users/')({
  component: RouteComponent,
})

function RouteComponent() {
  const api = useTRPC()

  const { data: users, isPending } = useQuery({
    ...api.superAdmin.getAllUsers.queryOptions(),
  })

  if (isPending)
    return (
      <DashboardShell>
        <DashboardHeader heading="Super Admin - User Management" />
        <Skeleton className="h-40 w-full" />
      </DashboardShell>
    )

  if (!users) return <div>No users found</div>

  return (
    <DashboardShell>
      <DashboardHeader heading="Super Admin - User Management" />
      <div className="rounded-md bg-amber-50 border border-amber-200 px-4 py-3 text-sm text-amber-800">
        <span className="font-medium">Super Admin View:</span> You can view and manage all users
        across all organizations. Use this view carefully as it affects users from all businesses.
      </div>
      <UsersDataTable columns={usersTableColumns} data={users} />
    </DashboardShell>
  )
}
